import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    overflow: "hidden",
  },
  dialogTitle: {
    textTransform: "capitalize",
    borderTopStyle: "solid",
    borderTopWidth: "2px",
  },
  dialogContent: {
    flex: "1 1 auto",
    position: "relative",
    overflow: "auto",
    paddingTop: 4,
    minHeight: "35vh",

    "& ul>li span": {
      paddingLeft: 0,
    },
  },

  title: {
    paddingLeft: 42,
    lineHeight: "32px",
  },
  levelBadge: {
    display: "flex",
    "&>div": {
      margin: "auto",
    },
  },
  subtitle: {
    display: "flex",
    alignItems: "center",
    lineHeight: "32px",
  },
  smallContent: {
    padding: `${theme.hv.spacing.xs}px 0`,
  },
  content: {
    padding: theme.hv.spacing.xs,
  },
  actionsSpacing: {
    "& > :not(:first-child)": {
      marginLeft: theme.hv.spacing.sm,
    },
  },
}));

export default useStyles;
